import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

// AUTENTICAÇÃO POR COOKIE (pós-migração Fase 3):
// withCredentials:true faz o handshake do WebSocket enviar o cookie HttpOnly
// blb_access. Como front (blbsystem.com.br) e API (api.blbsystem.com.br) são
// same-site e o cookie tem Domain=.blbsystem.com.br, ele viaja no handshake e
// o servidor (extractTokenFromHandshake) identifica o usuário. autoConnect:false
// mantido — a conexão só sobe quando há usuário logado (efeito abaixo).
const socketInstance = io(SOCKET_URL, { autoConnect: false, withCredentials: true });
const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        if (user && user.id) {
            socketInstance.connect();
            setSocket(socketInstance);

            const onConnectHandler = () => {
                // O servidor já resolve o tenant a partir do cookie blb_access no
                // handshake. Mantemos o emit newUser como reforço/compat (o servidor
                // aceita e reidrata pela sala correta). A leitura do token do
                // localStorage abaixo é legada: pós-migração retorna null e não tem
                // efeito — o tenant real vem do cookie no servidor.
                let activeTenantId = null;
                try {
                    const token = localStorage.getItem('token');
                    if (token) {
                        const base64Url = token.split('.')[1];
                        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                        const decoded = JSON.parse(atob(base64));
                        activeTenantId = decoded.active_tenant_id || null;
                    }
                } catch {}

                const userData = {
                    userId:           user.id,
                    nome:             user.nome,
                    avatar:           user.foto_perfil,
                    clienteId:        user.cliente_id || activeTenantId,
                    perfil:           user.perfil,
                    active_tenant_id: activeTenantId
                };

                socketInstance.emit('newUser', userData);
            };

            socketInstance.on('connect', onConnectHandler);

            return () => {
                socketInstance.off('connect', onConnectHandler);
                socketInstance.disconnect();
                setSocket(null);
            };
        } else {
            setSocket(null);
        }
    }, [user?.id]);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};